export { default } from "./Headings";
